module.exports = __webpack_public_path__ + "media/c1.f492b07f.mp3";